import { Injectable } from '@angular/core';

interface LogEntry {
  timestamp: Date,
  text: string,
}

@Injectable({
  providedIn: 'root'
})
export class ConsoleService {
  public messages: LogEntry[] = [];

  constructor() { }

  log(text: string): void {
    console.log(text);
    this.messages.push({
      timestamp: new Date(),
      text
    });
  }

  error(text: string): void {
    this.log('Error: ' + text);
  }
}
